// extracted by mini-css-extract-plugin
export default {"header":"vRbxRKafMxNUfVK2o2rq","title":"F2V7lcdEdxHOZz526ZFb"};